.item {
    background: white;
}
